import { render, staticRenderFns } from "./tixianrecord.vue?vue&type=template&id=2b413ad3&"
import script from "./tixianrecord.vue?vue&type=script&lang=js&"
export * from "./tixianrecord.vue?vue&type=script&lang=js&"
import style0 from "./tixianrecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports